// extracted by mini-css-extract-plugin
module.exports = {"close-button":"close-button_close-button__CLg4i","icon-black":"close-button_icon-black__YDPMN"};